export default array => array.filter(item => !item.settings.disabled)
